export default __webpack_public_path__ + "static/media/common-logo.5abafc63.svg";